import React, {useState, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import BSButton from 'react-bootstrap/Button';

const LinkButton = (props) => {

  let {
    label,
    href,
    block,
  } = props;

  return (
    <BSButton type="button" variant="default" size="xl" href={href} block={block}>
      {label}
    </BSButton>
  )

};

LinkButton.propTypes = {
  label: PropTypes.string,
  href: PropTypes.string,
};

export default LinkButton;
